import React from "react";
import "./ButtonGroup.scss";

// Fontaine M13 — ButtonGroup: lays Buttons out as one row on laptop and stacks them below 640px.

/**
 * @param {"start"|"end"|"center"|"stretch"} [align="start"]   horizontal alignment on laptop
 * @param {boolean} [equal]                                    equal widths (phone action pairs)
 * @param {"sm"|"md"} [stackBelow="sm"]                        breakpoint under which buttons stack full width
 * @param {boolean} [attached]                                 fuse the buttons into one segmented pill
 */
export default function ButtonGroup({ children, align = "start", equal = false, stackBelow = "sm", attached = false, className = "", ...rest }) {
  const classes = [
    "ft-btngroup",
    `ft-btngroup--${align}`,
    equal ? "ft-btngroup--equal" : "",
    attached ? "ft-btngroup--attached" : "",
    stackBelow ? `ft-btngroup--stack-${stackBelow}` : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={classes} role={attached ? "group" : undefined} {...rest}>
      {children}
    </div>
  );
}
